import { COTE_VAROISE } from './coteVaroise';
import { DESERT_CITY } from './desertCity';
import { LOMBARDIA } from './lombardia';
import { NORTHFIELD } from './northfield';
import { RIO_BAY } from './rioBay';
import { RIVIERA_HARBOUR } from './rivieraHarbour';
import type { TrackDef } from '../track';

/** The season calendar, in the original's order (design.md A3). */
export const CALENDAR: readonly TrackDef[] = [DESERT_CITY, RIVIERA_HARBOUR, LOMBARDIA, COTE_VAROISE, NORTHFIELD, RIO_BAY];

export function trackDefById(id: string): TrackDef {
  return CALENDAR.find((t) => t.id === id) ?? DESERT_CITY;
}
